/**
 * useRoster (CHAP-251) — Cabinet roster + edit.
 */
import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { apiGet, apiPatch } from '../lib/api.js';

export type MemberStatus = 'active' | 'resigning' | 'resigned' | 'on_leave';

export interface RosterMember {
  id: string;
  name: string;
  title: string | null;
  role: string;
  tier: string | null;
  committees: string[];
  memberStatus: MemberStatus;
  statusNote: string | null;
  appointedDate: string | null;
}

export function useRoster(slug: string) {
  return useQuery<{ roster: RosterMember[] }, Error>({
    queryKey: ['roster', slug],
    queryFn: () => apiGet(`/api/c/${slug}/roster`),
    enabled: !!slug,
  });
}

export function useUpdateMember(slug: string) {
  const qc = useQueryClient();
  return useMutation<unknown, Error, { id: string; memberStatus?: MemberStatus; statusNote?: string | null; title?: string | null }>({
    mutationFn: ({ id, ...body }) => apiPatch(`/api/c/${slug}/roster/${id}`, body),
    onSuccess: () => qc.invalidateQueries({ queryKey: ['roster', slug] }),
  });
}
